// Shared date-key helpers so the List and Calendar agree on "today".
//
// Events are stored as a plain `date` (YYYY-MM-DD) in the venue's wall-clock
// day. "Today" must therefore be computed in the venue timezone, not UTC or the
// browser's local zone — otherwise near midnight the two views disagree on
// which day is current.

const DEFAULT_TZ = 'America/New_York';

// First non-null venue_timezone among the events, else the default.
export function venueTz(events, fallback = DEFAULT_TZ) {
  if (Array.isArray(events)) {
    for (const e of events) {
      if (e && e.venue_timezone) return e.venue_timezone;
    }
  }
  return fallback;
}

// Today as a YYYY-MM-DD key in the given timezone. en-CA formats as ISO.
export function todayKeyInTz(tz = DEFAULT_TZ) {
  try {
    return new Intl.DateTimeFormat('en-CA', { timeZone: tz }).format(new Date());
  } catch {
    return new Date().toLocaleDateString('en-CA');
  }
}

// { y, m (0-based), d } → YYYY-MM-DD. Mirrors the calendar grid's cell key.
export function dateKey(y, m, d) {
  return `${y}-${String(m + 1).padStart(2, '0')}-${String(d).padStart(2, '0')}`;
}

// Today's calendar coordinates { y, m (0-based), d } in the given timezone.
export function todayPartsInTz(tz = DEFAULT_TZ) {
  const [y, m, d] = todayKeyInTz(tz).split('-').map(Number);
  return { y, m: m - 1, d };
}
